import React from 'react';
import Icon from '../AppIcon';
import CampaignEmailLivePreview from './CampaignEmailLivePreview';
import { campaignEmailTemplateBannerImageUrl } from '../../api/campaigns';
import {
  campaignEmailTemplateId,
  templateUsesHubupVariable,
} from '../../utils/campaignEmailTemplate';
import {
  hubupSendStateFromSource,
  resolveHubupPreviewNotification,
} from './HubupNotificationPickerFields';
import {
  hubupButtonDesignFromSource,
  productCardOptionsFromSource,
} from '../../utils/emailButtonStyles';

export default function CampaignEmailTemplatePicker({
  campaign,
  templates,
  selectedId,
  onSelect,
  className = '',
}) {
  const list = templates || [];

  if (list.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-border bg-muted/20 px-4 py-8 text-center text-sm text-muted-foreground">
        Aucun template enregistré pour cette campagne.
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-1 gap-3 sm:grid-cols-2 ${className}`}>
      {list.map((template) => {
        const tid = campaignEmailTemplateId(template);
        const selected = tid === selectedId;
        const bannerUrl = campaignEmailTemplateBannerImageUrl(campaign, template);
        const usesHubup = templateUsesHubupVariable(template.emailTemplateHtml);
        const hubupPreview = usesHubup
          ? resolveHubupPreviewNotification(
              campaign,
              hubupSendStateFromSource(template),
              template,
            )
          : null;
        const productCardOptions = productCardOptionsFromSource(template);
        const hubupButtonDesign = hubupButtonDesignFromSource(template, campaign);

        return (
          <button
            key={tid}
            type="button"
            onClick={() => onSelect(tid)}
            className={`flex flex-col rounded-xl border-2 p-3 text-left transition-all ${
              selected
                ? 'border-primary bg-primary/5 shadow-md ring-1 ring-primary/20'
                : 'border-border bg-card hover:border-muted-foreground/30 hover:shadow-sm'
            }`}
          >
            <div className="mb-2 flex items-start justify-between gap-2">
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-foreground">
                  {template.name || 'Sans nom'}
                </p>
                <p className="mt-0.5 line-clamp-1 text-xs text-muted-foreground">
                  {template.emailTemplateSubject || 'Sans objet'}
                </p>
              </div>
              {selected ? (
                <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-primary px-2 py-0.5 text-[10px] font-medium text-primary-foreground">
                  <Icon name="Check" size={12} />
                  Choisi
                </span>
              ) : null}
            </div>
            <div className="mt-1 overflow-hidden rounded-lg border border-border/70 bg-[#f2f2f2]">
              <CampaignEmailLivePreview
                variant="thumb"
                sticky={false}
                emailPreviewMode="send"
                subject={template.emailTemplateSubject}
                html={template.emailTemplateHtml}
                bannerUrl={bannerUrl}
                productCardOptions={productCardOptions}
                hubupNotification={hubupPreview}
                hubupButtonDesign={hubupButtonDesign}
              />
            </div>
            {usesHubup ? (
              <p className="mt-2 text-[11px] text-muted-foreground">
                Notification HubUP à choisir à l&apos;étape d&apos;envoi.
              </p>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
